import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import {
  Button,
  Form,
  Col,
  Modal,
  Row,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { Spin } from "antd";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { SVGICON } from "../../../constant/theme";
import { post, postFormData } from "../../../helpers/api_helper";
import {
  POST_BranchLetterHeadImageUpload,
  POST_BranchReportingParametersSave,
  POST_BrancheInsert,
  POST_BranchesUpdate,
  POST_GetBranchDetailByID,
  POST_GetCategoryDropDownListByCategoryType,
  POST_ValidateLicenseLimit,
} from "../../../helpers/url_helper";
import QuickAddCategory from "../Categories/QuickAddCategory";
// import swal from "sweetalert";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  validateEmailField,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";

const BranchesReportingParameters = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [country, setCountry] = useState("");

  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [addBankModal, setAddBankModal] = useState(false);

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const reportingSignatureOptions = [
    { label: "Digital", value: 1 },
    { label: "Manual", value: 2 },
  ];

  const uLRNoGenerationTypeOptions = [
    { label: "TC Allocation", value: 1 },
    { label: "Report Printing", value: 2 },
  ];

  const reportPrintingPaperTypeOptions = [
    { label: "Blank Paper", value: 1 },
    { label: "Letter Head Paper", value: 2 },
  ];

  const reportPrintingHeaderTypeOptions = [
    { label: "Default", value: 0 },
    { label: "First Page Only Header Detail", value: 1 },
  ];

  const reportPrintingPerPageImageLimitOptions = [
    { label: "2", value: 2 },
    { label: "4", value: 4 },
    { label: "6", value: 6 },
  ];

  useEffect(() => {
    if (PrimaryIdParam) {
      getBranchDetailsByID();
    } else {
      validateLicenseLimit();
    }
  }, []);

  const validateLicenseLimit = async () => {
    setIsLoading(true);
    await post(POST_ValidateLicenseLimit, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
      FormNo: 42, //Branch Defination
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          // navigate("/branches");
          navigate(-1);
        } else {
          // getCountryDDL();
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getBranchDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetBranchDetailByID, {
      BranchIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            LetterHeadHeaderImageFileUrl:
              response?.LetterHeadHeaderImageFilePath,
            LetterHeadHeaderImageFilePath: "",
            LetterHeadFooterImageFileUrl:
              response?.LetterHeadFooterImageFilePath,
            LetterHeadFooterImageFilePath: "",
            NABLLogoFileUrl: response?.NABLLogoFilePath,
            NABLLogoFilePath: "",
            InvoiceLetterHeadHeaderImageFileUrl:
              response?.InvoiceLetterHeadHeaderImageFilePath,
            InvoiceLetterHeadHeaderImageFilePath: "",
            ILACLogoFileUrl: response?.ILACLogoFilePath,
            ILACLogoFilePath: "",
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    LetterHeadHeaderImageWidth: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 1)
          return Yup.string().required(
            "Letter Head Header Width is required field"
          );
        return schema;
      }
    ),

    LetterHeadHeaderImageHeight: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 1)
          return Yup.string().required(
            "Letter Head Header Height is required field"
          );
        return schema;
      }
    ),

    LetterHeadFooterImageWidth: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 1)
          if (
            LetterHeadFooterImageFilePath !== "" ||
            LetterHeadFooterImageFileUrl !== ""
          ) {
            return Yup.string().required(
              "Letter Head Footer Width is required field"
            );
          }
        return schema;
      }
    ),

    LetterHeadFooterImageHeight: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 1)
          if (
            LetterHeadFooterImageFilePath !== "" ||
            LetterHeadFooterImageFileUrl !== ""
          ) {
            return Yup.string().required(
              "Letter Head Footer Height is required field"
            );
          }
        return schema;
      }
    ),

    LetterHeadHeaderImageFilePath: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 1)
          if (LetterHeadHeaderImageFileUrl == "") {
            return Yup.string().required(
              "Letter Head Header Image File is required field"
            );
          }
        return schema;
      }
    ),

    NABLLogoWidth: Yup.string().when(
      "IsLetterHeadImageWithNABLLogo",
      ([IsLetterHeadImageWithNABLLogo], schema) => {
        if (IsLetterHeadImageWithNABLLogo == false)
          return Yup.string().required(
            "Letter Head NABL Logo Width is required field"
          );
        return schema;
      }
    ),

    NABLLogoHeight: Yup.string().when(
      "IsLetterHeadImageWithNABLLogo",
      ([IsLetterHeadImageWithNABLLogo], schema) => {
        if (IsLetterHeadImageWithNABLLogo == false)
          return Yup.string().required(
            "Letter Head NABL Logo Height is required field"
          );
        return schema;
      }
    ),

    LeftMarginToPrintNABLLogo: Yup.string().when(
      "IsLetterHeadImageWithNABLLogo",
      ([IsLetterHeadImageWithNABLLogo], schema) => {
        if (IsLetterHeadImageWithNABLLogo == false)
          return Yup.string().required(
            "Header Left Margin NABL Logo is required field"
          );
        return schema;
      }
    ),

    TopMarginToPrintNABLLogo: Yup.string().when(
      "IsLetterHeadImageWithNABLLogo",
      ([IsLetterHeadImageWithNABLLogo], schema) => {
        if (IsLetterHeadImageWithNABLLogo == false)
          return Yup.string().required(
            "Header Top Margin NABL Logo is required field"
          );
        return schema;
      }
    ),

    NABLLogoFilePath: Yup.string().when(
      "IsLetterHeadImageWithNABLLogo",
      ([IsLetterHeadImageWithNABLLogo], schema) => {
        if (IsLetterHeadImageWithNABLLogo == false)
          if (NABLLogoFileUrl == "") {
            return Yup.string().required("NABL Logo File is required field");
          }
        return schema;
      }
    ),

    PrePrintedStationaryHeaderHeight: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 2)
          return Yup.string().required(
            "Pre-Printed Stationary Header Height is required field"
          );
        return schema;
      }
    ),

    PrePrintedStationaryFooterHeight: Yup.string().when(
      "ReportPrintingPaperType",
      ([ReportPrintingPaperType], schema) => {
        if (ReportPrintingPaperType == 2)
          return Yup.string().required(
            "Pre-Printed Stationary Footer Height is required field"
          );
        return schema;
      }
    ),

    InvoicePrePrintedStationaryHeaderHeight: Yup.string().when(
      "InvoicePrintingPaperType",
      ([InvoicePrintingPaperType], schema) => {
        if (
          InvoicePrintingPaperType == 2 &&
          AuthUser?.Permissions?.Account == 1
        )
          return Yup.string().required(
            "Invoice Pre-Printed Stationary Header Height is required field"
          );
        return schema;
      }
    ),

    InvoiceLetterHeadHeaderImageWidth: Yup.string().when(
      "InvoicePrintingPaperType",
      ([InvoicePrintingPaperType], schema) => {
        if (
          InvoicePrintingPaperType == 1 &&
          AuthUser?.Permissions?.Account == 1
        )
          return Yup.string().required(
            "Invoice Letter Head Header Width is required field"
          );
        return schema;
      }
    ),

    InvoiceLetterHeadHeaderImageHeight: Yup.string().when(
      "InvoicePrintingPaperType",
      ([InvoicePrintingPaperType], schema) => {
        if (
          InvoicePrintingPaperType == 1 &&
          AuthUser?.Permissions?.Account == 1
        )
          return Yup.string().required(
            "Invoice Letter Head Header Height is required field"
          );
        return schema;
      }
    ),

    InvoiceLetterHeadHeaderImageFilePath: Yup.string().when(
      "InvoicePrintingPaperType",
      ([InvoicePrintingPaperType], schema) => {
        if (
          InvoicePrintingPaperType == 1 &&
          AuthUser?.Permissions?.Account == 1
        )
          if (InvoiceLetterHeadHeaderImageFileUrl == "") {
            return Yup.string().required(
              "Invoice Letter Head Header Image File is required field"
            );
          }
        return schema;
      }
    ),

    ILACLogoFilePath: Yup.string().when(
      "IsLetterHeadImageWithILACLogo",
      ([IsLetterHeadImageWithILACLogo], schema) => {
        if (
          IsLetterHeadImageWithILACLogo == false &&
          IsILACLogoApplicable == true
        )
          if (ILACLogoFileUrl == "") {
            return Yup.string().required("ILAC Logo File is required field");
          }
        return schema;
      }
    ),

    ILACLogoWidth: Yup.string().when(
      "IsLetterHeadImageWithILACLogo",
      ([IsLetterHeadImageWithILACLogo], schema) => {
        if (
          IsLetterHeadImageWithILACLogo == false &&
          IsILACLogoApplicable == true
        )
          return Yup.string().required(
            "Letter Head ILAC Logo Width is required field"
          );
        return schema;
      }
    ),

    ILACLogoHeight: Yup.string().when(
      "IsLetterHeadImageWithILACLogo",
      ([IsLetterHeadImageWithILACLogo], schema) => {
        if (
          IsLetterHeadImageWithILACLogo == false &&
          IsILACLogoApplicable == true
        )
          return Yup.string().required(
            "Letter Head ILAC Logo Height is required field"
          );
        return schema;
      }
    ),

    LeftMarginToPrintILACLogo: Yup.string().when(
      "IsLetterHeadImageWithILACLogo",
      ([IsLetterHeadImageWithILACLogo], schema) => {
        if (
          IsLetterHeadImageWithILACLogo == false &&
          IsILACLogoApplicable == true
        )
          return Yup.string().required(
            "Header Left Margin ILAC Logo is required field"
          );
        return schema;
      }
    ),

    TopMarginToPrintILACLogo: Yup.string().when(
      "IsLetterHeadImageWithILACLogo",
      ([IsLetterHeadImageWithILACLogo], schema) => {
        if (
          IsLetterHeadImageWithILACLogo == false &&
          IsILACLogoApplicable == true
        )
          return Yup.string().required(
            "Header Top Margin ILAC Logo is required field"
          );
        return schema;
      }
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      BranchIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      BranchName: "",

      BranchParameterIDEncrypt: "",
      ReportingSignature: 2,
      LetterHeadHeaderImageFilePath: "",
      LetterHeadHeaderImageFilekey: "",
      LetterHeadHeaderImageFileUrl: "",
      LetterHeadHeaderImageWidth: "",
      LetterHeadHeaderImageHeight: "",
      LetterHeadFooterImageFilePath: "",
      LetterHeadFooterImageFileKey: "",
      LetterHeadFooterImageFileUrl: "",
      LetterHeadFooterImageWidth: "",
      LetterHeadFooterImageHeight: "",
      NABLLogoFilePath: "",
      NABLLogoFileKey: "",
      NABLLogoFileUrl: "",
      NABLLogoWidth: "",
      NABLLogoHeight: "",
      IsLetterHeadImageWithNABLLogo: false,
      LeftMarginToPrintNABLLogo: "",
      TopMarginToPrintNABLLogo: "",
      ReportPrintingPaperType: 1,
      PrePrintedStationaryHeaderHeight: "",
      PrePrintedStationaryFooterHeight: "",
      ReportPrintingHeaderType: 0,
      ReportPrintingPerPageImageLimit: 6,
      ReportPrintingFirstPageDisclaimer: "",
      ReportPrintingFirstPageAuthorizedSignatoryName: "",
      ReportPrintingFirstPageQualityManagerName: "",
      InvoicePrintingPaperType: 1,
      InvoiceLetterHeadHeaderImageFilePath: "",
      InvoiceLetterHeadHeaderImageFilekey: "",
      InvoiceLetterHeadHeaderImageFileUrl: "",
      InvoiceLetterHeadHeaderImageWidth: "",
      InvoiceLetterHeadHeaderImageHeight: "",
      InvoicePrePrintedStationaryHeaderHeight: "",

      IsILACLogoApplicable: false,
      ILACLogoFilePath: "",
      ILACLogoFileKey: "",
      ILACLogoFileUrl: "",
      ILACLogoWidth: "",
      ILACLogoHeight: "",
      IsLetterHeadImageWithILACLogo: false,
      LeftMarginToPrintILACLogo: "",
      TopMarginToPrintILACLogo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      BranchIDEncrypt,
      IsLetterHeadImageWithNABLLogo,
      LetterHeadHeaderImageFilePath,
      LetterHeadHeaderImageFileKey,
      LetterHeadHeaderImageFileUrl,
      LetterHeadFooterImageFilePath,
      LetterHeadFooterImageFileKey,
      LetterHeadFooterImageFileUrl,
      NABLLogoFilePath,
      NABLLogoFileKey,
      NABLLogoFileUrl,
      LetterHeadHeaderImageWidth,
      LetterHeadFooterImageWidth,
      NABLLogoWidth,
      ReportPrintingHeaderType,
      InvoicePrintingPaperType,
      InvoiceLetterHeadHeaderImageFilePath,
      InvoiceLetterHeadHeaderImageFileKey,
      InvoiceLetterHeadHeaderImageFileUrl,
      InvoiceLetterHeadHeaderImageWidth,
      InvoiceLetterHeadHeaderImageHeight,
      InvoicePrePrintedStationaryHeaderHeight,

      IsILACLogoApplicable,
      ILACLogoFilePath,
      ILACLogoFileKey,
      ILACLogoFileUrl,
      ILACLogoWidth,
      IsLetterHeadImageWithILACLogo,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("BranchIDEncrypt", values?.BranchIDEncrypt);
    formData.append(
      "ReportingSignature",
      values?.ReportingSignature ? values?.ReportingSignature : 2
    );
    formData.append(
      "LetterHeadHeaderImageFilePath",
      values?.LetterHeadHeaderImageFilePath
    );
    formData.append(
      "LetterHeadHeaderImageFileUrl",
      values?.LetterHeadHeaderImageFileUrl
    );
    formData.append(
      "LetterHeadHeaderImageWidth",
      values?.LetterHeadHeaderImageWidth
    );
    formData.append(
      "LetterHeadHeaderImageHeight",
      values?.LetterHeadHeaderImageHeight
    );
    formData.append(
      "LetterHeadFooterImageFilePath",
      values?.LetterHeadFooterImageFilePath
    );
    formData.append(
      "LetterHeadFooterImageFileUrl",
      values?.LetterHeadFooterImageFileUrl
    );
    formData.append(
      "LetterHeadFooterImageWidth",
      values?.LetterHeadFooterImageWidth
    );
    formData.append(
      "LetterHeadFooterImageHeight",
      values?.LetterHeadFooterImageHeight
    );
    formData.append("NABLLogoFilePath", values?.NABLLogoFilePath);
    formData.append("NABLLogoFileUrl", values?.NABLLogoFileUrl);
    formData.append("NABLLogoWidth", values?.NABLLogoWidth);
    formData.append("NABLLogoHeight", values?.NABLLogoHeight);
    formData.append(
      "IsLetterHeadImageWithNABLLogo",
      values?.IsLetterHeadImageWithNABLLogo
    );
    formData.append(
      "LeftMarginToPrintNABLLogo",
      values?.LeftMarginToPrintNABLLogo
    );
    formData.append(
      "TopMarginToPrintNABLLogo",
      values?.TopMarginToPrintNABLLogo
    );
    formData.append(
      "ReportPrintingPaperType",
      values?.ReportPrintingPaperType ? values?.ReportPrintingPaperType : 1
    );
    formData.append(
      "PrePrintedStationaryHeaderHeight",
      values?.PrePrintedStationaryHeaderHeight
    );
    formData.append(
      "PrePrintedStationaryFooterHeight",
      values?.PrePrintedStationaryFooterHeight
    );

    formData.append(
      "ReportPrintingHeaderType",
      values?.ReportPrintingHeaderType
    );
    formData.append(
      "ReportPrintingPerPageImageLimit",
      values?.ReportPrintingPerPageImageLimit
    );
    formData.append(
      "ReportPrintingFirstPageDisclaimer",
      values?.ReportPrintingFirstPageDisclaimer
    );
    formData.append(
      "ReportPrintingFirstPageAuthorizedSignatoryName",
      values?.ReportPrintingFirstPageAuthorizedSignatoryName
    );
    formData.append(
      "ReportPrintingFirstPageQualityManagerName",
      values?.ReportPrintingFirstPageQualityManagerName
    );

    formData.append(
      "InvoicePrintingPaperType",
      values?.InvoicePrintingPaperType ? values?.InvoicePrintingPaperType : 1
    );
    formData.append(
      "InvoicePrePrintedStationaryHeaderHeight",
      values?.InvoicePrePrintedStationaryHeaderHeight
    );

    formData.append(
      "InvoiceLetterHeadHeaderImageFilePath",
      values?.InvoiceLetterHeadHeaderImageFilePath
    );
    formData.append(
      "InvoiceLetterHeadHeaderImageFileUrl",
      values?.InvoiceLetterHeadHeaderImageFileUrl
    );
    formData.append(
      "InvoiceLetterHeadHeaderImageWidth",
      values?.InvoiceLetterHeadHeaderImageWidth
    );
    formData.append(
      "InvoiceLetterHeadHeaderImageHeight",
      values?.InvoiceLetterHeadHeaderImageHeight
    );

    formData.append("IsILACLogoApplicable", values?.IsILACLogoApplicable);
    formData.append("ILACLogoFilePath", values?.ILACLogoFilePath);
    formData.append("ILACLogoFileUrl", values?.ILACLogoFileUrl);
    formData.append("ILACLogoWidth", values?.ILACLogoWidth);
    formData.append("ILACLogoHeight", values?.ILACLogoHeight);
    formData.append(
      "IsLetterHeadImageWithILACLogo",
      values?.IsLetterHeadImageWithILACLogo
    );
    formData.append(
      "LeftMarginToPrintILACLogo",
      values?.LeftMarginToPrintILACLogo
    );
    formData.append(
      "TopMarginToPrintILACLogo",
      values?.TopMarginToPrintILACLogo
    );

    postFormData(POST_BranchLetterHeadImageUpload, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/branches");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageTitle, setImageTitle] = useState("");
  const [imageSrc, setImageSrc] = useState("");
  const [imageWidth, setImageWidth] = useState("");

  const uploadLetterHeadHeaderImageFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
        formik.setFieldValue(
          "LetterHeadHeaderImageFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("LetterHeadHeaderImageFilePath", file);
      }
    } else {
      formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
      formik.setFieldValue(
        "LetterHeadHeaderImageFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const viewLetterHeadHeaderImage = (e) => {
    setImageSrc(
      LetterHeadHeaderImageFilePath
        ? URL.createObjectURL(LetterHeadHeaderImageFilePath)
        : LetterHeadHeaderImageFileUrl
    );
    setImageWidth(
      LetterHeadHeaderImageWidth ? LetterHeadHeaderImageWidth + "mm" : "210mm"
    );
    setImageTitle("Letter Head Header Image");
    setShowImageModal(true);
  };

  const deleteLetterHeadHeaderImage = (e) => {
    formik.setFieldValue("LetterHeadHeaderImageFilePath", "");
    formik.setFieldValue(
      "LetterHeadHeaderImageFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("LetterHeadHeaderImageFileUrl", "");
  };

  const uploadLetterHeadFooterImageFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("LetterHeadFooterImageFilePath", "");
        formik.setFieldValue(
          "LetterHeadFooterImageFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("LetterHeadFooterImageFilePath", file);
      }
    } else {
      formik.setFieldValue("LetterHeadFooterImageFilePath", "");
      formik.setFieldValue(
        "LetterHeadFooterImageFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const viewLetterHeadFooterImage = (e) => {
    setImageSrc(
      LetterHeadFooterImageFilePath
        ? URL.createObjectURL(LetterHeadFooterImageFilePath)
        : LetterHeadFooterImageFileUrl
    );
    setImageWidth(
      LetterHeadFooterImageWidth ? LetterHeadFooterImageWidth + "mm" : "210mm"
    );
    setImageTitle("Letter Head Footer Image");
    setShowImageModal(true);
  };

  const deleteLetterHeadFooterImage = (e) => {
    formik.setFieldValue("LetterHeadFooterImageFilePath", "");
    formik.setFieldValue(
      "LetterHeadFooterImageFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("LetterHeadFooterImageFileUrl", "");
  };

  const uploadNABLLogoFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("NABLLogoFilePath", "");
        formik.setFieldValue(
          "NABLLogoFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("NABLLogoFilePath", file);
      }
    } else {
      formik.setFieldValue("NABLLogoFilePath", "");
      formik.setFieldValue(
        "NABLLogoFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const viewNABLLogo = (e) => {
    setImageSrc(
      NABLLogoFilePath ? URL.createObjectURL(NABLLogoFilePath) : NABLLogoFileUrl
    );
    setImageWidth(NABLLogoWidth ? NABLLogoWidth + "mm" : "32mm");
    setImageTitle("Letter Head NABL Logo Image");
    setShowImageModal(true);
  };

  const deleteNABLLogo = (e) => {
    formik.setFieldValue("NABLLogoFilePath", "");
    formik.setFieldValue(
      "NABLLogoFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("NABLLogoFileUrl", "");
  };

  const deleteInvoiceLetterHeadHeaderImage = (e) => {
    formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
    formik.setFieldValue(
      "InvoiceLetterHeadHeaderImageFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("InvoiceLetterHeadHeaderImageFileUrl", "");
  };

  const viewInvoiceLetterHeadHeaderImage = (e) => {
    setImageSrc(
      InvoiceLetterHeadHeaderImageFilePath
        ? URL.createObjectURL(InvoiceLetterHeadHeaderImageFilePath)
        : InvoiceLetterHeadHeaderImageFileUrl
    );
    setImageWidth(
      InvoiceLetterHeadHeaderImageWidth
        ? InvoiceLetterHeadHeaderImageWidth + "mm"
        : "210mm"
    );
    setImageTitle("Invoice Letter Head Header Image");
    setShowImageModal(true);
  };

  const uploadInvoiceLetterHeadHeaderImageFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
        formik.setFieldValue(
          "InvoiceLetterHeadHeaderImageFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", file);
      }
    } else {
      formik.setFieldValue("InvoiceLetterHeadHeaderImageFilePath", "");
      formik.setFieldValue(
        "InvoiceLetterHeadHeaderImageFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const uploadILACLogoFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.png|.gif|.jpeg|.jpg)$/;

      if (!file.type.match(pattern)) {
        warningMessage("Select valid file!");
        formik.setFieldValue("ILACLogoFilePath", "");
        formik.setFieldValue(
          "ILACLogoFileKey",
          Math.random().toString(9).substring(2, 9)
        );
      } else {
        formik.setFieldValue("ILACLogoFilePath", file);
      }
    } else {
      formik.setFieldValue("ILACLogoFilePath", "");
      formik.setFieldValue(
        "ILACLogoFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const viewILACLogo = (e) => {
    setImageSrc(
      ILACLogoFilePath ? URL.createObjectURL(ILACLogoFilePath) : ILACLogoFileUrl
    );
    setImageWidth(ILACLogoWidth ? ILACLogoWidth + "mm" : "32mm");
    setImageTitle("Letter Head NABL Logo Image");
    setShowImageModal(true);
  };

  const deleteILACLogo = (e) => {
    formik.setFieldValue("ILACLogoFilePath", "");
    formik.setFieldValue(
      "ILACLogoFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("ILACLogoFileUrl", "");
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Branch Parameters Details</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">Reporting Parameters Details</h5>
                </div>

                <div className="">
                  <Row>
                    <Col lg={3}>
                      <label>
                        Reporting Signature{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                If set to 'Digital,' the signature uploaded in
                                the employee master record will be printed on
                                the report. If set to 'Manual,' the report will
                                need to be signed by hand after printing.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportingSignature"
                        placeholder={"Select Status"}
                        options={reportingSignatureOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Report Print Paper Type{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Select the type of paper for printing reports:
                                'Blank Paper' or 'Letterhead Paper.'
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingPaperType"
                        placeholder={"Select Paper Type"}
                        options={reportPrintingPaperTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        ILAC Logo Applicable{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Confirm that the ILAC logo is prominently
                                displayed on your letterhead.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsILACLogoApplicable"
                          name="IsILACLogoApplicable"
                          checked={IsILACLogoApplicable}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsILACLogoApplicable",
                              e.target.checked
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="IsILACLogoApplicable"
                        >
                          ILAC Logo Applicable
                        </label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      {(LetterHeadHeaderImageFileUrl ||
                        LetterHeadHeaderImageFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteLetterHeadHeaderImage}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewLetterHeadHeaderImage}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          Letter Head Header Image{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Upload the image to be used as the header on
                                  letterhead paper for report printing.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="LetterHeadHeaderImageFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={LetterHeadHeaderImageFileKey || ""}
                          onChange={(e) => {
                            uploadLetterHeadHeaderImageFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="LetterHeadHeaderImageFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head Header Width x Height(mm){" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the dimensions of the letterhead header
                                image in millimeters to ensure proper alignment
                                on the paper.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LetterHeadHeaderImageWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LetterHeadHeaderImageWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="LetterHeadHeaderImageHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "LetterHeadHeaderImageHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>

                    <Col lg={3}>
                      {(LetterHeadFooterImageFileUrl ||
                        LetterHeadFooterImageFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteLetterHeadFooterImage}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewLetterHeadFooterImage}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          Letter Head Footer Image{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Upload the image to be used in the header of
                                  the letterhead. Ensure the image is in the
                                  correct format and resolution for clear and
                                  professional presentation.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="LetterHeadFooterImageFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={LetterHeadFooterImageFileKey || ""}
                          onChange={(e) => {
                            uploadLetterHeadFooterImageFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="LetterHeadFooterImageFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head Footer Width x Height (mm){" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the dimensions for the footer section of
                                the letterhead. Ensure accurate measurements for
                                proper alignment and formatting on the printed
                                document.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LetterHeadFooterImageWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LetterHeadFooterImageWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="LetterHeadFooterImageHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "LetterHeadFooterImageHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <label>
                        Letter Head Image With NABL Logo{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Upload the image of the letterhead that includes
                                the NABL logo. This image will be used as the
                                template for official documents, ensuring that
                                the NABL logo is prominently displayed on your
                                letterhead.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsLetterHeadImageWithNABLLogo"
                          name="IsLetterHeadImageWithNABLLogo"
                          checked={IsLetterHeadImageWithNABLLogo}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsLetterHeadImageWithNABLLogo",
                              e.target.checked
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="IsLetterHeadImageWithNABLLogo"
                        >
                          Letter Head Image With NABL Logo
                        </label>
                      </div>
                    </Col>
                    <Col lg={3}>
                      {(NABLLogoFileUrl || NABLLogoFilePath) && (
                        <>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="Delete"
                            style={{ float: "right" }}
                            onClick={deleteNABLLogo}
                          >
                            {SVGICON.DeleteDanger}
                          </Link>
                          <Link
                            to="#"
                            className="icon-box icon-box-md me-1"
                            title="View"
                            style={{ float: "right" }}
                            onClick={viewNABLLogo}
                          >
                            <i className="fa fa-image"></i>
                          </Link>
                        </>
                      )}
                      <div className="mb-2">
                        <label>
                          NABL Logo{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  Upload the NABL logo to be included on
                                  official documents. This logo represents
                                  accreditation and compliance with NABL
                                  standards.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="NABLLogoFilePath"
                          accept="image/png, image/gif, image/jpeg"
                          key={NABLLogoFileKey || ""}
                          onChange={(e) => {
                            uploadNABLLogoFile(e);
                          }}
                        />
                        <ErrorMessage
                          name="NABLLogoFilePath"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label>
                        Letter Head NABL Logo Width x Height{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Specify the dimensions (width x height) of the
                                NABL logo to be included on the letterhead.
                                Ensure that these measurements are accurate for
                                proper placement and scaling.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="NABLLogoWidth"
                          placeholder={"Width (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "NABLLogoWidth",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="mt-2 ms-1 me-1">x</div>
                        <Field
                          type="number"
                          name="NABLLogoHeight"
                          placeholder={"Height (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "NABLLogoHeight",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>

                    <Col lg={3}>
                      <label>
                        Header Left - Top margin for NABL Logo{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the top margin from the left edge of the
                                header where the NABL logo will be positioned.
                                This setting ensures proper alignment of the
                                NABL logo on your letterhead.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <div className="d-flex">
                        <Field
                          type="number"
                          name="LeftMarginToPrintNABLLogo"
                          placeholder={"Left (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 211) {
                              formik.setFieldValue(
                                "LeftMarginToPrintNABLLogo",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                        <div className="ms-1 me-1"></div>
                        <Field
                          type="number"
                          name="TopMarginToPrintNABLLogo"
                          placeholder={"Top (mm)"}
                          component={CustomInput}
                          onChange={(e) => {
                            if (e?.target?.value < 100) {
                              formik.setFieldValue(
                                "TopMarginToPrintNABLLogo",
                                e?.target?.value
                              );
                            }
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                  {IsILACLogoApplicable && (
                    <Row>
                      <Col lg={3}>
                        <label>
                          Letter Head Image With ILAC Logo{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Upload the image of the letterhead that
                                  includes the ILAC logo. This image will be
                                  used as the template for official documents,
                                  ensuring that the ILAC logo is prominently
                                  displayed on your letterhead.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="mb-2 form-control form-control-sm">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="IsLetterHeadImageWithILACLogo"
                            name="IsLetterHeadImageWithILACLogo"
                            checked={IsLetterHeadImageWithILACLogo}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "IsLetterHeadImageWithILACLogo",
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="IsLetterHeadImageWithILACLogo"
                          >
                            Letter Head Image With ILAC Logo
                          </label>
                        </div>
                      </Col>
                      <Col lg={3}>
                        {(ILACLogoFileUrl || ILACLogoFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteILACLogo}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="View"
                              style={{ float: "right" }}
                              onClick={viewILACLogo}
                            >
                              <i className="fa fa-image"></i>
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label>
                            ILAC Logo{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Upload the ILAC logo to be included on
                                    official documents. This logo represents
                                    accreditation and compliance with ILAC
                                    standards.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="ILACLogoFilePath"
                            accept="image/png, image/gif, image/jpeg"
                            key={ILACLogoFileKey || ""}
                            onChange={(e) => {
                              uploadILACLogoFile(e);
                            }}
                          />
                          <ErrorMessage
                            name="ILACLogoFilePath"
                            component="div"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <label>
                          Letter Head ILAC Logo Width x Height{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  Specify the dimensions (width x height) of the
                                  ILAC logo to be included on the letterhead.
                                  Ensure that these measurements are accurate
                                  for proper placement and scaling.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="d-flex">
                          <Field
                            type="number"
                            name="ILACLogoWidth"
                            placeholder={"Width (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 211) {
                                formik.setFieldValue(
                                  "ILACLogoWidth",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                          <div className="mt-2 ms-1 me-1">x</div>
                          <Field
                            type="number"
                            name="ILACLogoHeight"
                            placeholder={"Height (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 100) {
                                formik.setFieldValue(
                                  "ILACLogoHeight",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                        </div>
                      </Col>

                      <Col lg={3}>
                        <label>
                          Header Left - Top margin for ILAC Logo{" "}
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            responsive={true}
                            overlay={
                              <Tooltip className="toltip-popover">
                                <strong className="p-1">
                                  {" "}
                                  Specify the top margin from the left edge of
                                  the header where the ILAC logo will be
                                  positioned. This setting ensures proper
                                  alignment of the ILAC logo on your letterhead.
                                </strong>
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                className="fa fa-info-circle"
                                style={{ cursor: "pointer", color: "#9698ab" }}
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <div className="d-flex">
                          <Field
                            type="number"
                            name="LeftMarginToPrintILACLogo"
                            placeholder={"Left (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 211) {
                                formik.setFieldValue(
                                  "LeftMarginToPrintILACLogo",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                          <div className="ms-1 me-1"></div>
                          <Field
                            type="number"
                            name="TopMarginToPrintILACLogo"
                            placeholder={"Top (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 100) {
                                formik.setFieldValue(
                                  "TopMarginToPrintILACLogo",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col lg={3}>
                      <label>
                        Pre-Printed Stationary Header Height {/* (mm) */}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the height of the header on pre-printed
                                stationary. This measurement ensures that the
                                content aligns correctly with the existing
                                header area.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="PrePrintedStationaryHeaderHeight"
                        placeholder={"Height (mm)"}
                        component={CustomInput}
                        onChange={(e) => {
                          if (e?.target?.value < 100) {
                            formik.setFieldValue(
                              "PrePrintedStationaryHeaderHeight",
                              e?.target?.value
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Pre-Printed Stationary Footer Height {/* (mm) */}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Specify the height of the footer on pre-printed
                                stationary. This measurement ensures that the
                                content aligns correctly with the existing
                                footer area.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        type="number"
                        name="PrePrintedStationaryFooterHeight"
                        placeholder={"Height (mm)"}
                        component={CustomInput}
                        onChange={(e) => {
                          if (e?.target?.value < 100) {
                            formik.setFieldValue(
                              "PrePrintedStationaryFooterHeight",
                              e?.target?.value
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <label>
                        Report Print Header Type{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Choose the type of header for printing report:
                                The 'Default' type repeats the header detail
                                when needed, while 'First Page Only Header
                                Detail' prints the header detail only on the
                                first page, with the test results starting from
                                the second page.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{
                                cursor: "pointer",
                                color: "#9698ab",
                              }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingHeaderType"
                        placeholder={"Select Header Type"}
                        options={reportPrintingHeaderTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                    {ReportPrintingHeaderType == 1 && (
                      <>
                        {" "}
                        <Col lg={3}>
                          <label>
                            Report Disclaimer{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Disclaimer to print on test report
                                    first page when report print header type is
                                    'First Page Only Header Detail'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageDisclaimer"
                            placeholder={"Enter Disclaimer"}
                            component={CustomInput}
                            maxLength={1000}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Report Authorized Signatory{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Authorized Signatory Name to print
                                    on test report first page when report print
                                    header type is 'First Page Only Header
                                    Detail'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageAuthorizedSignatoryName"
                            placeholder={"Enter Authorized Signatory Name"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Report Quality Manager{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Set the Quality Manager Name to print on
                                    test report first page when report print
                                    header type is 'First Page Only Header
                                    Detail. If not required to print keep it
                                    blank.'
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ReportPrintingFirstPageQualityManagerName"
                            placeholder={"Enter Quality Manager Name"}
                            component={CustomInput}
                            maxLength={100}
                          />
                        </Col>
                      </>
                    )}

                    <Col lg={3}>
                      <label>
                        Report Print Per Page Test Image{" "}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                Set the number of images per page for printing
                                report
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{
                                cursor: "pointer",
                                color: "#9698ab",
                              }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ReportPrintingPerPageImageLimit"
                        placeholder={"Select Per Page Image"}
                        options={reportPrintingPerPageImageLimitOptions}
                        component={CustomSelect}
                        isClearable={false}
                      />
                    </Col>
                  </Row>
                </div>
                {AuthUser?.Permissions?.Account == 1 ? (
                  <>
                    <hr className="mt-1 mb-1"></hr>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Invoice Parameters Details</h5>
                    </div>
                    <div className="">
                      <Row>
                        <Col lg={3}>
                          <label>
                            Invoice Print Paper Type{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Choose the type of paper for printing
                                    invoices: Blank Paper or Letterhead Paper.
                                    Select 'Letterhead Paper' if you want to use
                                    pre-printed stationery with a letterhead, or
                                    'Blank Paper' for standard printing on plain
                                    sheets.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="InvoicePrintingPaperType"
                            placeholder={"Select Paper Type"}
                            options={reportPrintingPaperTypeOptions}
                            component={CustomSelect}
                            isClearable={false}
                          />
                        </Col>

                        <Col lg={3}>
                          {(InvoiceLetterHeadHeaderImageFileUrl ||
                            InvoiceLetterHeadHeaderImageFilePath) && (
                            <>
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                style={{ float: "right" }}
                                onClick={deleteInvoiceLetterHeadHeaderImage}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="View"
                                style={{ float: "right" }}
                                onClick={viewInvoiceLetterHeadHeaderImage}
                              >
                                <i className="fa fa-image"></i>
                              </Link>
                            </>
                          )}
                          <div className="mb-2">
                            <label>
                              Invoice Letter Head Header Image{" "}
                              <OverlayTrigger
                                trigger={["hover", "focus"]}
                                responsive={true}
                                overlay={
                                  <Tooltip className="toltip-popover">
                                    <strong className="p-1">
                                      Upload the image to be used as the header
                                      on the invoice letterhead. This image will
                                      appear at the top of the invoice printout,
                                      typically including your company logo or
                                      other identifying information.
                                    </strong>
                                  </Tooltip>
                                }
                              >
                                <span>
                                  <i
                                    className="fa fa-info-circle"
                                    style={{
                                      cursor: "pointer",
                                      color: "#9698ab",
                                    }}
                                  ></i>
                                </span>
                              </OverlayTrigger>
                            </label>
                            <input
                              type="file"
                              className="form-control form-control-sm"
                              id="InvoiceLetterHeadHeaderImageFilePath"
                              accept="image/png, image/gif, image/jpeg"
                              key={InvoiceLetterHeadHeaderImageFileKey || ""}
                              onChange={(e) => {
                                uploadInvoiceLetterHeadHeaderImageFile(e);
                              }}
                            />
                            <ErrorMessage
                              name="InvoiceLetterHeadHeaderImageFilePath"
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                          </div>
                        </Col>
                        <Col lg={3}>
                          <label>
                            Invoice Pre-Printed Stationary Header Height{" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Specify the height (in millimeters) of the
                                    header section on pre-printed invoice
                                    stationery. This defines the vertical space
                                    allocated for the header content on the
                                    paper.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            type="number"
                            name="InvoicePrePrintedStationaryHeaderHeight"
                            placeholder={"Height (mm)"}
                            component={CustomInput}
                            onChange={(e) => {
                              if (e?.target?.value < 100) {
                                formik.setFieldValue(
                                  "InvoicePrePrintedStationaryHeaderHeight",
                                  e?.target?.value
                                );
                              }
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <label>
                            Invoice Letter Head Header Width x Height(mm){" "}
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    Specify the width and height (in
                                    millimeters) for the header section of the
                                    invoice letterhead. This defines the area
                                    where the header image will be placed.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <div className="d-flex">
                            <Field
                              type="number"
                              name="InvoiceLetterHeadHeaderImageWidth"
                              placeholder={"Width (mm)"}
                              component={CustomInput}
                              onChange={(e) => {
                                if (e?.target?.value < 211) {
                                  formik.setFieldValue(
                                    "InvoiceLetterHeadHeaderImageWidth",
                                    e?.target?.value
                                  );
                                }
                              }}
                            />
                            <div className="mt-2 ms-1 me-1">x</div>
                            <Field
                              type="number"
                              name="InvoiceLetterHeadHeaderImageHeight"
                              placeholder={"Height (mm)"}
                              component={CustomInput}
                              onChange={(e) => {
                                if (e?.target?.value < 100) {
                                  formik.setFieldValue(
                                    "InvoiceLetterHeadHeaderImageHeight",
                                    e?.target?.value
                                  );
                                }
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <hr className="mt-1 mb-2"></hr>
                <button type="submit" className="btn btn-primary btn-sm me-2">
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showImageModal}
          onHide={setShowImageModal}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>{imageTitle}</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowImageModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body className="ps-1 pt-0">
            <img src={imageSrc} style={{ maxWidth: imageWidth }} />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default BranchesReportingParameters;
